<div class="main_div">
  <div style="margin-bottom: 32px">
    <span
      class="colored cursor"
      *ngIf="getCurrentUrl === 'corporate'"
      [routerLink]="getCurrentUrl === 'corporate' ? '/corporate/corporate-dashboard' : '/'"
      >Home /</span
    >
    <span
      class="colored cursor"
      [routerLink]="
        fromPreviousPage
          ? fromPreviousPage
          : '/corporate/campaigns/all-campaigns'
      "
      *ngIf="getCurrentUrl === 'corporate'"
    >
      {{ fromPreviousPage ? "CSR Donation /" : "Campaigns /" }}
    </span>
    {{
      getCurrentUrl === "corporate"
        ? queryParams?.title
        : queryParams?.breadcrumb
    }}
  </div>

  <header class="counter">
    <div class="more-options">
      <div class="survey-status">
        <b class="employee-satisfaction-survey">{{ queryParams?.title }}</b>
      </div>
    </div>
  </header>

  <div class="main_body">
    <div class="tab_div">
      <div class="main_body_title">Responses</div>
      <div class="tab_div w-auto">
        <div
          class="tab"
          [class.active]="activeTab === 1"
          (click)="activeTab = 1"
        >
          <img
            [src]="
              activeTab === 1
                ? './assets/images/icon/dashboard_icon_active.svg'
                : './assets/images/icon/dashboard_icon_inactive.svg'
            "
          />
          Dashboard
        </div>
        <div
          *ngIf="queryParams?.breadcrumb === 'Campaign'"
          class="tab"
          [class.active]="activeTab === 2"
          (click)="activeTab = 2"
        >
          <img
            [src]="
              activeTab === 2
                ? './assets/images/icon/info_active_icon.svg'
                : './assets/images/icon/info_inactive_icon.svg'
            "
          />
          Details
        </div>
      </div>
    </div>

    @if(activeTab === 1) {
    <div class="carts_row">
      <div class="overview_carts">
        <div *ngFor="let carts of row2" class="carts">
          <div class="upper_part">
            <div>
              <div class="left_side">
                <div class="carts_description fw-bold">
                  {{ carts.carts_name }}
                </div>
                <div class="carts_description fs-6 fw-normal">
                  {{ carts.carts_description }}
                </div>
              </div>
            </div>
            <div class="right_side">
              <div class="carts_img">
                <img loading="lazy" [src]="carts.carts_icon" />
              </div>
            </div>
          </div>
          <div class="upper_part">
            <div class="carts_description fw-bold">
              <span style="color: #0054a6" *ngIf="carts.isAmount">৳</span>
              {{ carts.calculated_data | number }}
            </div>
          </div>
        </div>
      </div>
      <div class="overview_carts">
        <div *ngFor="let carts of row1; let i = index" class="carts sec">
          <div class="upper_part">
            <div class="left_side">
              <div class="carts_description fw-bold">
                {{ carts.carts_name }}
              </div>
              <div class="carts_description fs-6 fw-normal">
                {{ carts.carts_description }}
              </div>
            </div>
            <div class="right_side">
              <div class="carts_img">
                <img loading="lazy" [src]="carts.carts_icon" alt="" />
              </div>
            </div>
          </div>
          <div class="upper_part">
            <div class="carts_description fw-bold">
              <span style="color: #0054a6" *ngIf="carts.isAmount">৳</span>
              {{ carts.calculated_data | number }} {{ i === 2 ? " %" : "" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title_select_box">
      <div class="main_body_title">Campaigns Analytics</div>
      <dx-select-box
        [dataSource]="[
          { value: 'bar-chart', label: 'Donation' },
          { value: 'line-chart', label: 'Participating' }
        ]"
        displayExpr="label"
        valueExpr="value"
        [(value)]="selectedChart"
        (onValueChanged)="onChartChange($event)"
        class="chart-select"
      ></dx-select-box>
    </div>

    <div class="chart_donation_history">
      @if(selectedChart === 'line-chart'){
      <div class="chart-container">
        <div class="chart_header">
          <div class="abcd text-start">
            <div class="recent_donation">Employee Participating</div>
            <img
              loading="lazy"
              src="./assets/images/icon/trending_up_icon.svg"
              alt="Donor"
              title="donor"
              class="for_donor"
            />
            <span class="font_16 recent_donated_text"
              >{{ getTotalEmployees }} Participation in last
              {{ lineChartDays }}</span
            >
          </div>
          <dx-select-box
            [dataSource]="[
              { value: 'last15Days', label: 'Last Fortnight' },
              { value: 'lastWeek', label: 'Last Week' },
              { value: 'lastMonth', label: 'Last Month' }
            ]"
            displayExpr="label"
            valueExpr="value"
            [(value)]="selectedPeriod"
            class="chart-select second_chart"
            (onValueChanged)="onTimePeriodChange($event)"
          ></dx-select-box>
        </div>
        <dx-chart
          [dataSource]="lineChartData"
          [palette]="'extrapolate'"
          class="line_chart"
        >
          <dxi-series
            argumentField="formattedDate"
            valueField="total_employee"
            name="Total Employee"
            type="line"
            color="#0054A6"
            width="5"
          >
          </dxi-series>
          <dxo-marker
            [visible]="true"
            color="#FFD602"
            size="20"
            shape="circle"
          ></dxo-marker>
          <dxo-common-series-settings
            argumentField="formattedDate"
            type="line"
          ></dxo-common-series-settings>
          <dxo-tooltip [enabled]="true"> </dxo-tooltip>
          <dxo-value-axis>
            <dxo-label> </dxo-label>
          </dxo-value-axis>
          <dxo-argument-axis
            [valueMarginsEnabled]="false"
            discreteAxisDivisionMode="crossLabels"
          >
            <dxo-grid [visible]="true"></dxo-grid>
          </dxo-argument-axis>
          <dxo-legend
            verticalAlignment="top"
            horizontalAlignment="center"
            position="outside"
            backgroundColor="none"
          >
          </dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
        </dx-chart>
      </div>
      }@else{
      <div class="chart-container">
        <div class="chart_header">
          <div class="abcd text-start">
            <div class="recent_donation">Donation Analytics</div>
            <img
              loading="lazy"
              src="./assets/images/icon/trending_up_icon.svg"
              alt="Donor"
              title="donor"
              class="for_donor"
            />
            <span class="font_16 recent_donated_text"
              >{{ getTotalAmount }} Total Collection in last
              {{ lineChartDays }}</span
            >
          </div>
          <dx-select-box
            [dataSource]="[
              { value: 'last15Days', label: 'Last Fortnight' },
              { value: 'lastWeek', label: 'Last Week' },
              { value: 'lastMonth', label: 'Last Month' }
            ]"
            displayExpr="label"
            valueExpr="value"
            [(value)]="selectedPeriod"
            class="chart-select second_chart"
            (onValueChanged)="onTimePeriodChange($event)"
          ></dx-select-box>
        </div>
        <dx-chart
          [barGroupWidth]="40"
          id="chart"
          class="chart_div"
          [dataSource]="donations"
        >
          <dxo-break-style line="waved"></dxo-break-style>
          <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
          <dxo-scroll-bar [visible]="true"></dxo-scroll-bar>
          <dxo-animation
            easing="linear"
            [duration]="500"
            [maxPointCountSupported]="300"
          >
          </dxo-animation>
          <dxo-legend
            verticalAlignment="top"
            horizontalAlignment="center"
            position="outside"
            backgroundColor="none"
          >
          </dxo-legend>
          <dxi-series
            argumentField="formattedDate"
            valueField="total_matched_amount"
            name="Matched"
            type="bar"
            color="#FFD602"
            barWidth="28"
            cornerRadius="0px"
            stack="sameGroup"
          >
          </dxi-series>
          <dxi-series
            argumentField="formattedDate"
            valueField="total_amount"
            name="Collected"
            type="bar"
            color="#0054a6"
            barWidth="28"
            cornerRadius="0px"
            stack="sameGroup"
          >
          </dxi-series>
          <!-- <dxo-argument-axis
            [visualRange]="{
              length: 0
            }"
          >
          </dxo-argument-axis> -->
          <dxo-common-series-settings
            argumentField="formattedDate"
            type="bar"
            hoverMode="allArgumentPoints"
            selectionMode="allArgumentPoints"
          >
          </dxo-common-series-settings>
        </dx-chart>
      </div>
      }
      <div class="donation_summary">
        <div class="donor-container">
          <div class="abcd text-start mt-4 mb-4 w-100">
            <div class="recent_donation">Recent Donation</div>
            <img
              loading="lazy"
              src="../../../../../assets/images/icon/trending_up_icon.svg"
              alt="Donor"
              title="donor"
              class="for_donor"
            />
            <span class="font_16 recent_donated_text"
              >{{ row1[0].calculated_data }} people just donated</span
            >
          </div>
          <div class="donor_list_container">
            <!-- <dx-button class="blue-button-md" style="width: 100%"
              >Donation</dx-button
            > -->
            <div *ngFor="let item of donationSummary" class="donor_list">
              <div class="d-flex gap-2">
                <div class="donor_icon_div">
                  <img
                    src="../../../../../assets/images/icon/donor_icon_blue.png"
                    alt="Donor"
                    title="donor"
                  />
                </div>
                <div class="d-flex gap-2 flex-column">
                  <span class="font_18">{{ item?.name }} </span>
                  <span class="font_16">
                    ৳{{ item?.amount }}
                    <span
                      style="
                        margin-left: 5px;
                        color: #4d4d4d;
                        text-decoration: underline;
                        font-size: 11px;
                        font-weight: 400;
                      "
                    >
                      {{ item?.time }} ago</span
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="main_body_title" style="margin-bottom: 32px">
        Employee Participation List
      </div>
      <dx-data-grid
        class="donor_list_data_grid"
        [dataSource]="donationSummary"
        [showBorders]="false"
        [showColumnLines]="false"
        [showRowLines]="false"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        [focusedRowEnabled]="false"
        [rowAlternationEnabled]="false"
        rowTemplate="rowDonationList"
        [wordWrapEnabled]="true"
        [columnAutoWidth]="true"
      >
        <dxo-paging [pageSize]="10" [pageIndex]="0"> </dxo-paging>
        <dxo-pager
          *ngIf="donationSummary?.length > 10"
          [visible]="true"
          [showPageSizeSelector]="false"
          [allowedPageSizes]="[10]"
          [showInfo]="false"
          [showNavigationButtons]="true"
        >
        </dxo-pager>
        <dxo-search-panel
          [visible]="true"
          [width]="600"
          placeholder="Search..."
        >
        </dxo-search-panel>
        <dxo-header-filter
          [visible]="true"
          [allowSearch]="true"
        ></dxo-header-filter>
        <dxo-scrolling
          [scrollByContent]="true"
          columnRenderingMode="virtual"
          showScrollbar="always"
        ></dxo-scrolling>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxi-column caption="Serial No" alignment="left"></dxi-column>
        <dxi-column
          caption="Employee Name"
          dataField="name"
          alignment="left"
        ></dxi-column>
        <dxi-column
          caption="Email"
          dataField="email"
          alignment="center"
          [allowSorting]="false"
          [allowFiltering]="false"
        ></dxi-column>
        <dxi-column
          caption="Date & Time"
          dataField="created_at"
          alignment="center"
          [allowFiltering]="false"
        >
        </dxi-column>
        <dxi-column
          caption="Amount"
          dataField="amount"
          alignment="center"
          style="border: none"
        >
        </dxi-column>
        <dxi-column
          caption="Receipt"
          dataField="payment_receipt"
          alignment="center"
          style="border: none"
          [allowFiltering]="false"
        >
        </dxi-column>
        <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
          <tr style="display: contents !important">
            <td>
              <div class="donor-name">
                {{ row?.rowIndex + 1 }}
              </div>
            </td>
            <td>
              <div class="donor-profile row_white">
                <div class="profile-avatar">
                  <img
                    class="profile_img"
                    loading="lazy"
                    [src]="
                      row?.data?.profile_img ||
                      './assets/images/round_profile.png'
                    "
                    alt=""
                  />
                </div>
                <div class="profile-details">
                  <div class="donor-name fs_18 c_0054a6 cursor">
                    {{ row?.data?.name }}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="donor-name">
                {{ row?.data?.email || "N/A" }}
              </div>
            </td>
            <td>
              <div class="profile-details">
                <div class="donor-name">
                  {{ row?.data?.created_at | date : "dd MMM yyyy" }}
                </div>
                <div class="donor-email">
                  {{ row?.data?.created_at | date : "hh:mm a" }}
                </div>
              </div>
            </td>
            <td>
              <div class="donor-name">
                ৳ {{ (row?.data?.amount | number) || 0 }}
              </div>
            </td>
            <td>
              <div>
                <button
                  class="blue-button-sm"
                  (click)="openReceipt(row?.data?.payment_receipt)"
                >
                  Receipt
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </dx-data-grid>
    </div>
    } @if(activeTab === 2 && queryParams?.breadcrumb === 'Campaign') {
    <app-campaign-details
      style="width: 100%"
      [ngoId]="queryParams?.ngo_id"
      [projectId]="queryParams?.project_id"
      [campaignId]="queryParams?.campaign_id"
      [showFundraisers]="false"
      [showDonationSummary]="false"
    ></app-campaign-details>
    }
  </div>
</div>
